export const POINT_STORE_CARDS = '/point-store-cards'
export const RAFFLE = '/raffles'
